import { render, staticRenderFns } from "./serviceRepair.vue?vue&type=template&id=0084691a&scoped=true&"
import script from "./serviceRepair.vue?vue&type=script&lang=js&"
export * from "./serviceRepair.vue?vue&type=script&lang=js&"
import style0 from "./serviceRepair.vue?vue&type=style&index=0&id=0084691a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0084691a",
  null
  
)

export default component.exports